import { render, staticRenderFns } from "./MessageJoin.vue?vue&type=template&id=601c312e&scoped=true&"
import script from "./MessageJoin.vue?vue&type=script&lang=ts&"
export * from "./MessageJoin.vue?vue&type=script&lang=ts&"
import style0 from "./MessageJoin.vue?vue&type=style&index=0&id=601c312e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c312e",
  null
  
)

export default component.exports